import { AppLink } from '@crm/components'
import { SettingsForm } from '@crm/features/billing/components'
import { getRoute } from '@crm/utils'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'

const formName = 'company-settings'

export const SettingsPage = () => {
  const { t } = useLocales()

  return (
    <>
      <TitleSection title={t('billing.company_settings')}>
        <AppLink to={getRoute('BillingInvoices')}>
          <Button>{t('buttons.cancel')}</Button>
        </AppLink>

        <Button type="primary" htmlType="submit" form={formName}>
          {t('buttons.save')}
        </Button>
      </TitleSection>

      <Flex justify="center">
        <SettingsForm formName={formName} />
      </Flex>
    </>
  )
}
